import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import countries from '../../../../json/country.json'
import axios from '../../../../lib/axios'

const FormIndividuKatalogProgram = (props) => {

    const size = useWindowSize();
    const user = props?.user?.Account !== undefined ? props.user : {};

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)
    const categoryUser = useSelector(state => state.categoryUserSelected)

    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])
    const [subDistricts, setSubDistricts] = useState([])

    const handleChangeFormInput = (key, e) => {
        if (key === 'SET_FILE_KIP_INDIVIDU') {
            dispatch({ type: key, 'value': e.target.files[0] });
        } else {
            dispatch({ type: key, 'value': e.target.value });
        }
    }

    useEffect(() => {
        dispatch({ type: 'SET_SALUTATION_INDIVIDU', 'value': user.salutation !== null ? user.salutation : '' });
        dispatch({ type: 'SET_NAMADEPAN_PIC', 'value': user.firstName !== null ? user.firstName : '' });
        dispatch({ type: 'SET_NAMABELAKANG_PIC', 'value': user.lastName !== null ? user.lastName : '' });
        dispatch({ type: 'SET_EMAIL_PIC', 'value': user.email !== null ? user.email : '' });
        dispatch({ type: 'SET_CODE_HP_PIC', 'value': '+62' });
        dispatch({ type: 'SET_HP_PIC', 'value': user.mobilePhone !== null ? user.mobilePhone : '' });
        dispatch({ type: 'SET_KIP_INDIVIDU', 'value': user.identityType !== null ? user.identityType : '' });
        dispatch({ type: 'SET_NIK_INDIVIDU', 'value': user.identityNumber !== null ? user.identityNumber : '' });
        dispatch({ type: 'SET_PEKERJAAN_INDIVIDU', 'value': user.job !== null ? user.job : '' });
        dispatch({ type: 'SET_NAMA_PERUSAHAAN_INDIVIDU', 'value': user.companyName !== null ? user.companyName : '' });
        dispatch({ type: 'SET_JABATAN_INDIVIDU', 'value': user.jobPosition !== null ? user.jobPosition : '' });
        dispatch({ type: 'SET_PROVINSI_ID_INDIVIDU', 'value': user.Account.billingState !== null ? user.Account.billingState : '' });
        dispatch({ type: 'SET_KOTA_ID_INDIVIDU', 'value': user.Account.billingCity !== null ? user.Account.billingCity : '' });
        dispatch({ type: 'SET_KECAMATAN_ID_INDIVIDU', 'value': user.Account.billingSubdistrict !== null ? user.Account.billingSubdistrict : '' });
        dispatch({ type: 'SET_KODEPOS_INDIVIDU', 'value': user.Account.billingZip !== null ? user.Account.billingZip : '' });
        dispatch({ type: 'SET_PATOKAN_INDIVIDU', 'value': user.Account.billingStreet !== null ? user.Account.billingStreet : '' });

    }, [])

    // console.log(user)

    return (
        <>
            <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '2%' }}>1. Silahkan lengkapi Data Peserta berikut untuk lanjut ke proses pembayaran.</p>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='salutationIndividu' className="form-label">Salutation</label>
                    <input type="text" id='salutationIndividu' className="form-control" value={dataInputRegistration.salutationIndividu} disabled />
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaDepanIndividu' className="form-label">Nama Depan</label>
                    <input type="text" id='NamaDepanIndividu' className="form-control" value={dataInputRegistration.namaDepanPic} disabled />
                </div>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaBelakangIndividu' className="form-label">Nama Belakang</label>
                    <input type="text" id='NamaBelakangIndividu' className="form-control" value={dataInputRegistration.namaBelakangPic} disabled />
                </div>
                <p className='mt-2' style={{ fontSize: '12px', fontWeight: '400' }}>Apabila nama anda terdiri dari satu kata: Nama Depan : <b>Budianto</b>, Nama Belakang : <b>Budianto</b></p>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='EmailIndividu' className="form-label">Email</label>
                    <input type="email" id='EmailIndividu' className="form-control" value={dataInputRegistration.emailPic} disabled />
                </div>
                <div className='row col-lg-6 col-12'>
                    <div className='col-lg-4 col-12'>
                        <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='CountryIndividu' className="form-label">Negara</label>
                        <select className="form-select" id='CountryIndividu' value={dataInputRegistration.codeHpPic} disabled>
                            <option value="+62">Indonesia</option>
                            {countries.countries.map((country, key) =>
                                <option value={country.code}>{country.name}</option>
                            )}
                        </select>
                    </div>
                    <div className='col-lg-8 col-12'>
                        <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='Country' className="form-label">Nomor Handphone</label>
                        <input type="text" id='Country' className="form-control" placeholder='81224567890' value={dataInputRegistration.hpPic} disabled />
                    </div>
                    <p className='mt-2' style={{ fontSize: '12px', fontWeight: '400' }}>Contoh : 8122456789 (Gunakan nomor yang terhubung dengan WhatsApp)</p>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (dataInputRegistration.kartuIdentitasIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }} htmlFor="KartuIdentitasPeserta" className="form-label">Kartu Identitas Peserta</label>
                    <select className="form-select" aria-label="Select example" id='KartuIdentitasPeserta' onChange={(e) => handleChangeFormInput('SET_KIP_INDIVIDU', e)} value={dataInputRegistration.kartuIdentitasIndividu}
                        style={{ borderColor: (dataInputRegistration.kartuIdentitasIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }} disabled={true}
                    >
                        <option value=''>Pilih</option>
                        <option value='NIK'>NIK</option>
                        <option value='NPWP'>NPWP</option>
                    </select>
                </div>
                <div className='col-lg-6 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (dataInputRegistration.nikIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }} htmlFor='NikIndividu' className="form-label">Nomor Identitas (NIK/NPWP)</label>
                    <input type="text" id='NikIndividu' className="form-control mb-2" placeholder='Nomor Identitas (NIK/NPWP)' onChange={(e) => handleChangeFormInput('SET_NIK_INDIVIDU', e)} value={dataInputRegistration.nikIndividu}
                        style={{ borderColor: (dataInputRegistration.nikIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                        disabled
                    />
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-12 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (dataInputRegistration.pekerjaanIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }} htmlFor='PekerjaanIndividu' className="form-label">Pekerjaan</label>
                    <input type="text" id='PekerjaanIndividu' className="form-control mb-2" placeholder='Pekerjaan' onChange={(e) => handleChangeFormInput('SET_PEKERJAAN_INDIVIDU', e)} value={dataInputRegistration.pekerjaanIndividu}
                        style={{ borderColor: (dataInputRegistration.pekerjaanIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                        disabled
                    />
                    <p style={{ fontSize: '12px', fontWeight: '400' }}>Contoh: Karyawan</p>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-12 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaPerusahaanIndividu' className="form-label">Nama Perusahaan</label>
                    <input type="text" id='NamaPerusahaanIndividu' className="form-control mb-2" placeholder='Nama Perusahaan' onChange={(e) => handleChangeFormInput('SET_NAMA_PERUSAHAAN_INDIVIDU', e)} value={dataInputRegistration.namaPerusahaanIndividu} disabled />
                    <p style={{ fontSize: '12px', fontWeight: '400' }}>Contoh: Maju Abadi, PT</p>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-12 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='JabatanIndividu' className="form-label">Jabatan</label>
                    <input type="text" id='JabatanIndividu' className="form-control mb-2" placeholder='Jabatan' onChange={(e) => handleChangeFormInput('SET_JABATAN_INDIVIDU', e)} value={dataInputRegistration.jabatanIndividu} disabled />
                </div>
            </div>
            <div className='row' style={{ marginBottom: '2%' }}>
                <div className='col-lg-12 col-12 mb-2'>
                    <label className="form-label" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }}>Alamat Perusahaan</label>
                </div>
                <div className='col-lg-4 col-12'>
                    <label htmlFor='Provinsi' className="form-label" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }}>Provinsi</label>
                    <input type="text" id='Provinsi' className="form-control mb-2" placeholder='Provinsi' disabled={true} value={user?.Account?.billingState} />

                </div>
                <div className='col-lg-4 col-12'>
                    <label htmlFor='Kota' className="form-label" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }}>Kota</label>
                    <input type="text" id='Kota' className="form-control mb-2" placeholder='Kota' disabled={true} value={user?.Account?.billingCity} />
                </div>
                <div className='col-lg-4 col-12'>
                    <label htmlFor='Kecamatan' className="form-label" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }}>Kecamatan</label>
                    <input type="text" id='Kecamatan' className="form-control mb-2" placeholder='Kecamatan' disabled={true} value={user?.Account?.billingSubdistrict} />
                </div>
                <div className='col-lg-4 col-12'>
                    <label htmlFor='Kodepos' className="form-label" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }}>Kode Pos</label>
                    <input type="text" id='Kodepos' className="form-control mb-2" placeholder='Kode Pos' disabled={true} value={user?.Account?.billingZip} />
                </div>
                <div className='col-lg-8 col-12'>
                    <label htmlFor='PatokanPerusahaan' className="form-label" style={{ fontSize: size.width < 500 ? '14px' : '16px', fontWeight: '600' }}>Nama Jalan, Gedung, Nomor/Blok</label>
                    <input type="text" id='PatokanPerusahaan' className="form-control mb-2" placeholder='Nama Jalan, Gedung, Nomor/Blok' disabled={true} value={user?.Account?.billingStreet} />
                </div>
            </div>
        </>
    )
}

export default FormIndividuKatalogProgram
